import { useQmsBackToExamRoomMutation } from '../../generated/graphql';

export default useQmsBackToExamRoomMutation;
